import React from 'react';
import { Modal } from 'antd';
import ResetPassword from 'routes/PasswordInputes/ResetPassword';
import { getTheme } from 'helpers/getTheme';

type ChangePasswordPops = {
  isOpen: boolean;
  onCancel: () => void;
};

const ChangePassword = ({ isOpen, onCancel }: ChangePasswordPops) => {  
  return (
    <Modal
      open={isOpen}
      width={'400px'}
      onCancel={onCancel}
      onOk={onCancel}
      centered
      footer={null}
      className={getTheme()}
      cancelButtonProps={{style: {display: 'none'}}}
    >
      <ResetPassword isModal={true}/>
    </Modal>
  );
};

export default ChangePassword;
